import React, { Component } from 'react'

import Logo from '../../components/whiteLogo'
import Menu from '../../components/cn/menu'

// const debounce = (func, wait) => {
// let timeout
// return (...args) => {
// clearTimeout(timeout)
// timeout = setTimeout(() => func.apply(this, args), wait)
// }
// }
class Nav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      on: false,
      scrollPositionY: 0,
    }
  }

  componentDidMount() {
    // window.addEventListener('scroll', debounce(this.handleScroll, 16))
    window.addEventListener('scroll', this.handleScroll)
  }
  componentWillUnmount() {
    // window.removeEventListener('scroll', debounce(this.handleScroll, 16))
    window.removeEventListener('scroll', this.handleScroll)
  }
  handleScroll = () => {
    const scrollPositionY = +window.scrollY
    this.setState({ scrollPositionY })
  }

  toggle = () => {
    this.setState({
      on: !this.state.on,
    })
  }

  render() {
    const isScrolling = !!this.state.scrollPositionY
    return (
      <div className={isScrolling ? 'navbar scrolling' : 'navbar'}>
        <Logo />
        {this.state.on ? (
          <button className="nav-button toggled" onClick={this.toggle}>
            <span className="ham ham-1" />
            <span className="ham ham-2" />
            <span className="ham ham-3" />
          </button>
        ) : (
          <button className="nav-button" onClick={this.toggle}>
            <span className="ham ham-1" />
            <span className="ham ham-2" />
            <span className="ham ham-3" />
          </button>
        )}

        {this.state.on ? <Menu /> : null}
      </div>
    )
  }
}

export default Nav
